import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const ContentWrapper = styled.footer`
  border-top: 1px solid #EFEAF4;
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  text-align: center;
  font-size: 0.8rem;
  font-family: 'Noto Sans KR', sans-serif;
`

const Footer = ({ author }) => (
  <ContentWrapper>
    © 2014-{new Date().getFullYear()} {author}
    {` / `}
    <a href="https://www.gatsbyjs.org">Gatsby</a>로 만듬
  </ContentWrapper>
)

Footer.propTypes = {
  author: PropTypes.string,
}

Footer.defaultProps = {
  author: ``,
}

export default Footer
